import { createServiceStoreFactory } from '@app/services/base/store/create-service-store-factory';
import { WaterNewContractServiceService } from '@app/services/water-new-contract/services/water-new-contract-service.service';
import { WaterNewContractService } from '@app/services/water-new-contract/classes/water-new-contract-service';

export const WaterNewContractServiceStore = createServiceStoreFactory(
    'WaterNewContract',
    WaterNewContractService,
    WaterNewContractServiceService,
);
